import { useEffect, useState } from 'react';
import ErrorMessageBlock from '../ErrorMessageBlock.jsx';
import { businessApiRoute, get } from '../../lib/Api';

const WarnIfZoomNotConfigured = ({ message, className }) => {
    const [isConfigured, setIsConfigured] = useState(true);
    useEffect(() => {
        get(businessApiRoute('/integrations/other/zoom')).then(result => {
            if (!result.connected) {
                setIsConfigured(false);
            }
        });
    }, []);

    if (isConfigured) {
        return null;
    }

    return (
        <ErrorMessageBlock className={className}>{message}</ErrorMessageBlock>
    );
};

export default WarnIfZoomNotConfigured;
